import React from 'react';
import { Reveal } from './Reveal';
import { bonuses, BONUS_TOTAL } from '../data/bonuses';
export function BonusesSection() {
  return <section className="bg-brand-main px-4 py-20 md:py-24" data-id="element-33" data-mp="gx6my2oga68c">
      <Reveal className="mx-auto max-w-3xl" data-id="element-34" data-mp="vtfm748ccjkr">
        <div className="mb-10 text-center" data-id="element-35" data-mp="vu7hsf1xuhb1">
          <h2 className="text-3xl font-extrabold text-brand-deep md:text-4xl" data-id="element-36" data-mp="qt9zm2gxhn9j">🎁 Bonus GRATUITI inclusi</h2>
          <p className="mt-3 text-brand-gray" data-id="element-37" data-mp="14ssuhtkqb23w">Oltre all&apos;ebook, sono inclusi questi regali</p>
        </div>
        <ol className="space-y-3" data-id="element-38" data-mp="ztg9ledf453y">
          {bonuses.map(({
          icon: BonusIcon,
          title,
          description,
          price
        }, index) => <li key={title} className="flex items-start gap-4 rounded-2xl border border-brand-sand bg-brand-alt p-5 shadow-sm sm:gap-5" data-id="element-39" data-mp="1eiukiqwn6ulg" data-mpi={index}>
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brand-ocean font-display text-sm font-bold text-white" data-id="element-40" data-mp="1nl3r55osi3tk">
                {index + 1}
              </span>
              <BonusIcon className="mt-0.5 hidden h-7 w-7 shrink-0 text-brand-amber sm:block" strokeWidth={1.6} aria-hidden="true" data-id="element-41" data-mp="3prdb803yejsc" />
              <div className="min-w-0 flex-1" data-id="element-42" data-mp="3ttzz5pxi7kk9">
                <h3 className="font-bold leading-snug text-brand-deep" data-id="element-43" data-mp="2lcoc3ww3fqy">{title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-brand-gray" data-id="element-44" data-mp="7kfkszyt0dnb">{description}</p>
                <p className="mt-2 flex flex-wrap items-center gap-2 text-xs" data-id="element-45" data-mp="cjs81ltl7mqf">
                  <span className="font-semibold text-brand-gray line-through" data-id="element-46" data-mp="chz8eqhe62rx">{price}</span>
                  <span className="rounded-full bg-brand-ocean/10 px-2 py-0.5 font-extrabold tracking-wide text-brand-ocean" data-id="element-47" data-mp="gjani22n35lv">
                    GRATIS
                  </span>
                </p>
              </div>
            </li>)}
        </ol>
        <p className="mt-8 text-center font-display text-xl font-bold text-brand-deep" data-id="element-48" data-mp="vbcknedbrki7">
          Questi bonus hanno un valore totale di <span className="text-brand-amber" data-id="element-49" data-mp="109mg7q2yon4c">{BONUS_TOTAL}</span>
        </p>
      </Reveal>
    </section>;
}